export type GroupByValue = {
	label: string;
	sort: string | number | [string, number];
};

export function sortByGroupByValue(a: GroupByValue | undefined, b: GroupByValue | undefined, order: 'asc' | 'desc') {
	if (a === undefined || b === undefined) {
		return 0;
	}

	let [first, second] = [a, b];
	if (order === 'desc') {
		[first, second] = [b, a];
	}

	if (Array.isArray(first.sort) && Array.isArray(second.sort)) {
		if (first.sort[0] === second.sort[0]) {
			return first.sort[1] - second.sort[1];
		}

		return second.sort[0].localeCompare(first.sort[0]);
	}

	if (typeof first.sort === 'string' && typeof second.sort === 'string') {
		return second.sort.localeCompare(first.sort);
	}

	if (typeof first.sort === 'number' && typeof second.sort === 'number') {
		return first.sort - second.sort;
	}

	return 0;
}
